<div id="page">
  <div id="header">
    <div id="header__center">
      <h1 i18n id="header__center__title">settings</h1>
      <button mat-icon-button class="close__button"
      routerLink="../game"><i class="material-icons-round">clear</i></button>
    </div>
  </div>

  <div class="settings">
    <div class="settings__container">
      <h2 i18n class="settings__title">grid dimensions</h2>
      
      <mat-slider
        color="primary"
        [min]="min"
        [max]="max"
        [value]="valueDimensions"
        [thumbLabel]="true"
        (change)="selectGridDimension($event)"
      ></mat-slider>
    </div>

    <div class="settings__container">
      <h2 i18n class="settings__title">hard mode</h2>
        <div class="settings__tile-container">
          <mat-slide-toggle
          color="primary"
          [checked]="isHard"
          (change)="switchDifficulty()"
          ></mat-slide-toggle>
        </div>
    </div>

    <div class="settings__container">
      <h2 i18n class="settings__title">theme</h2>

      <div class="settings__bubble-container">
        <div
          (click)="selectTheme($event)"
          class="settings__bubble"
          id="light"
        ></div>
        <div
          (click)="selectTheme($event)"
          class="settings__bubble"
          id="chrome"
        ></div>
        <div
          (click)="selectTheme($event)"
          class="settings__bubble"
          id="dark"
        ></div>
        <div
          (click)="selectTheme($event)"
          class="settings__bubble"
          id="amoled"
        ></div>
      </div>
    </div>

    <div class="settings__container">
      <h2 i18n class=settings__title>color</h2>

      <div class="settings__bubble-container">
        <div
        (click)="selectColor($event)"
        class="settings__bubble"
        id="multicolor"></div>

        <div
        (click)="selectColor($event)"
        class="settings__bubble"
        id="light-blue"></div>

        <div
        (click)="selectColor($event)"
        class="settings__bubble"
        id="red"></div>

        <div
        (click)="selectColor($event)"
        class="settings__bubble"
        id="orange"></div>

        <div
        (click)="selectColor($event)"
        class="settings__bubble"
        id="green"></div>

        <div
        (click)="selectColor($event)"
        class="settings__bubble"
        id="indigo"></div>

        <div
        (click)="selectColor($event)"
        class="settings__bubble"
        id="purple"></div>


      </div>
    </div>

    <div class="settings__container">
      <h2 i18n class="settings__title">accessibility</h2>

      <div class="settings__tile-container">
        <div
          (click)="selectAccessibility($event)"
          class="settings__tile"
          id="false"
        ></div>
        <div
          (click)="selectAccessibility($event)"
          class="settings__tile"
          id="true"
        ></div>
      </div>
    </div>
  </div>

  <footer>
  <p>Romain Gianolio & Yann Lacroix</p>

  <p>v 1.1 - ©2020</p>
  </footer>
</div>